// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"menuItem_2baN04_isw","menuIcon":"menuIcon_1v3AMujvZc","active":"active_2IqszgbN8n"};